import { Flex } from '@sequencehq/core-components'
import type { ReactNode } from 'react'

/**
 * Fixed 24×24 centered slot for the leading icon or logo of a command-palette
 * row. Keeps every row's content aligned regardless of the inner glyph size.
 */
export const IconSlot = ({ children }: { children: ReactNode }) => (
  <Flex w="24px" h="24px" align="center" justify="center" flexShrink={0}>
    {children}
  </Flex>
)
